var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebstripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8389 22H4.16111C2.96758 22 2 21.0325 2 19.8389V4.16111C2 2.96758 2.96758 2 4.16111 2H19.8389C21.0325 2 22 2.96758 22 4.16111V19.8389C22 21.0325 21.0325 22 19.8389 22Z",
    fill: "#7F7F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1542 9.05555C11.1542 8.51979 11.5741 8.31379 12.2697 8.31379C13.267 8.31379 14.5268 8.62967 15.5242 9.19293V5.96489C14.435 5.51163 13.3589 5.33301 12.2697 5.33301C9.60563 5.33301 7.83398 6.78902 7.83398 9.22043C7.83398 13.0116 12.8209 12.4072 12.8209 14.0419C12.8209 14.6737 12.2959 14.8797 11.5611 14.8797C10.4718 14.8797 9.08076 14.4127 7.97837 13.7809V17.05C9.19887 17.5995 10.4324 17.833 11.5611 17.833C14.2906 17.833 16.1673 16.4181 16.1673 13.9594C16.1542 9.86594 11.1542 10.5941 11.1542 9.05555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebstripe);
export default __webpack_public_path__ + "static/media/icon_webstripe.65cb81f21243ab0baba30a2e7ca72d90.svg";
export { ForwardRef as ReactComponent };